type Listener = () => void;

const listeners = new Set<Listener>();

// Settings raises this after delete-all so a mounted runtime drops the open thread,
// without settings importing the Spec runtime chunk.
export function requestSpecThreadReset(): void {
  for (const listener of listeners) listener();
}

export function subscribeSpecThreadReset(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
